import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  TextField,
  Typography,
} from "@mui/material";
import { X } from "phosphor-react";
import Popup from "reactjs-popup";
import styled from "@emotion/styled";
import { CampoDeTexto } from "../../../../components/CampoInput";

export const ContainerGlobal = styled.div`
  padding: 64px 40px 20px;

  @media (max-width: 1100px) {
    margin-bottom: 30px;
  }
  @media (max-width: 768px) {
    padding: 64px 0px 20px;
  }
`;

export const Conteudo = styled.div`
  width: 100%;

  border-radius: 16px;
  background-color: ${({ theme }) => theme.cores.surface2};
`;

export const Navegacao = styled.div`
  display: flex;

  gap: 16px;
  padding-bottom: 19px;

  border-bottom: 1px solid rgba(0, 100, 149, 1);

  overflow: auto;

  @media (max-width: 768px) {
    gap: 0px;
    justify-content: center;
  }
`;
export const TextoNavegacao = styled.h2`
  display: flex;
  align-items: center;

  font-size: 17px;
  font-weight: 600;

  padding: 8px 32px;
  text-align: center;
  color: ${(props) => props.theme.adaptativo("neutral20", "neutral100")};
  cursor: pointer;

  &:hover {
    filter: brightness(0.7);
  }

  @media (max-width: 768px) {
    padding: 8px 10px;
  }
`;
export const TextoNavegacaoDestaque = styled.h2`
  display: flex;
  align-items: center;

  font-size: 19px;
  font-weight: 600;

  padding: 8px 32px;

  text-align: center;
  color: ${(props) => props.theme.adaptativo("actionActive", "neutral100")};
  border-bottom: 2px solid rgba(0, 100, 149, 1);

  cursor: pointer;

  &:hover {
    filter: brightness(0.7);
  }

  @media (max-width: 768px) {
    padding: 8px 10px;
  }
`;
export const CorpoConteudo = styled.main`
  padding: 30px 40px;

  @media (max-width: 768px) {
    padding: 30px 8px;
  }
`;

export const PrimeiroContainer = styled.div`
  display: flex;
  flex-direction: column;
  position: relative;
`;

export const Faturamento = styled.div`
  display: flex;
  flex-direction: column;
  gap: 20px;
  margin-bottom: 30px;
`;
export const TituloFaturamento = styled.h1`
  font-size: 19px;
  font-weight: 500;
  line-height: 21px;
  letter-spacing: 0.15;

  color: ${(props) => props.theme.adaptativo("neutral40", "neutral100")};
`;
export const ContainerInput = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;

  > label {
    font-size: 15px;
    font-weight: 400;
    line-height: 19px;
    letter-spacing: 0.25px;

    color: ${(props) => props.theme.adaptativo("neutral40", "neutral100")};
  }
`;

export const CheckBoxFaturamento = styled.input`
  width: 24px;
  height: 24px;
  background-color: white;
  border-radius: 50%;
  border: 1px solid #5a5f66;
  appearance: none;
  -webkit-appearance: none;

  background-color: ${(props) => props.theme.adaptativo("neutral100", "surface5")};

  &:checked {
    background-color: ${({ theme }) => theme.cores.actionActive};
    outline: 1px solid ${({ theme }) => theme.cores.actionActive};
    border: 3px solid ${(props) => props.theme.adaptativo("neutral100", "surface5")};
  }

  cursor: pointer;
`;

export const BotoesContrato = styled.div`
  display: flex;
  flex-direction: row;
  gap: 16px;
  margin-top: 50px;
  position: absolute;
  right: 0;

  @media (max-width: 768px) {
    display: flex;
    flex-direction: column;
    position: static;
    margin: 32px 8px;
  }
`;

export const PopupNovoContrato = styled(Popup)`
  &-overlay {
    pointer-events: none;
    overflow-y: auto;
  }

  &-content {
    width: 1025px;
    padding: 34px;
    border: 0;
    border-radius: 16px;

    background-color: ${(props) => props.theme.adaptativo("surface1", "surface2")};

    position: relative;
  }

  @media (max-width: 768px) {
    &-content {
      width: 100%;
      padding: 24px;
    }
  }
`;

export const PopupContent = styled.div`
  background-color: ${(props) => props.theme.adaptativo("surface1", "surface2")};
`;

export const ContainerBotaoTitulo = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: flex-start;

  border-bottom: 1px solid ${(props) => props.theme.cores.neutral80};
`;

export const XIcon = styled(X)`
  width: 20px;
  height: 20px;

  color: ${(props) => props.theme.cores.textoSimples};

  position: absolute;
  top: 2%;
  right: 1%;
`;

export const TituloModal = styled.div`
  font-size: 33px;
  line-height: 37px;
  font-family: "Comfortaa", sans-serif;
  padding: 10px;

  color: ${({ theme }) => theme.cores.textoSimples};
`;

export const BotaoFecharModal = styled.button`
  border: none;
  background-color: transparent;

  cursor: pointer;
`;

export const ContainerCardsContrato = styled.div`
  display: flex;
  justify-content: center;
  gap: 40px;

  margin-top: 55px;

  @media (max-width: 800px) {
    flex-direction: column;
  }
`;

export const CardContratos = styled.button`
  padding: 30px;
  border: none;
  border-radius: 16px;
  outline: 1px solid ${(props) => props.theme.adaptativo("corCardRelatorioClientes", "surface4")};

  background-color: ${(props) => props.theme.adaptativo("corCardRelatorioClientes", "brand60")};
  text-align: left;

  cursor: pointer;

  outline: 1px solid
    ${({ theme, hasBorder }) =>
      hasBorder ? theme.adaptativo("brand40Default", "surface6") : "none"};

  @media (max-width: 1000px) {
    padding: 15px;
  }
`;

export const TituloCard = styled.div`
  font-size: 20px;
  font-weight: 700;
  font-family: "Comfortaa", sans-serif;
  line-height: 25px;
  color: ${(props) => props.theme.cores.textoSimples};
  margin-bottom: 22px;
`;

export const TextoCard = styled.p`
  font-size: 17px;
  font-family: "Source Sans Pro", sans-serif;
  line-height: 21px;
  color: ${(props) => props.theme.cores.textoSimples};
`;

export const ContainerBotoesModal = styled.div`
  display: flex;
  gap: 30px;
  justify-content: right;

  margin-top: 40px;
`;

export const ContainerDadosNovoContrato = styled.div`
  display: flex;
  margin-top: 50px;
  gap: 150px;

  @media (max-width: 768px) {
    flex-direction: column;
    gap: 32px;
  }
`;

export const TextoTextField = styled.div`
  > p {
    font-size: 19px;
    font-weight: 600;
    margin-bottom: 40px;
  }

  @media (max-width: 768px) {
    > p {
      font-size: 17px;
    }
  }
`;

export const ContainerAlteracaoNovoPlano = styled.div`
  margin: 0 auto;
  width: 415px;
  padding: 24px;
  border-radius: 16px;
  background-color: ${(props) => props.theme.adaptativo("surface3", "surface4")};

  > h1 {
    font-size: 23px;
    font-weight: 700;
    font-family: "Comfortaa", sans-serif;
    line-height: 25px;
    margin-bottom: 35px;
  }

  > p {
    font-size: 19px;
    color: ${(props) => props.theme.adaptativo("textoContrato", "neutral100")};
  }

  > p:not(:last-child) {
    margin-bottom: 8px;
  }

  > p > span {
    font-size: 19px;
    font-weight: 600;
  }

  @media (max-width: 768px) {
    > p {
      font-size: 17px;
    }

    > p > span {
      font-size: 17px;
    }
  }

  @media (max-width: 450px) {
    width: 100%;
  }
`;

export const ConteudoCobrancaContrato = styled.div`
  > p {
    font-size: 19px;
    margin: 16px 0;
  }
`;

export const CheckboxContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 14px;

  margin-bottom: 30px;
`;

export const LabelEInput = styled.div`
  display: flex;
`;

export const LabelCheckbox = styled.label`
  font-size: 15px;
  color: ${(props) => props.theme.adaptativo("neutral10", "neutral90")};

  font-family: "Source Sans Pro", sans-serif;
  letter-spacing: 0.25px;
`;
export const TextFieldNovoContrato = styled(TextField)`
  &.MuiTextField-root {
    width: 100%;
    background-color: ${(props) => props.theme.adaptativo("surface1", "neutral10")};
  }

  .MuiSelect-select {
    font-size: 16px;
    font-family: "Open Sans", sans-serif;
    color: rgba(121, 116, 126, 1);
  }
`;

export const StyledAccordionSimples = styled(Accordion)`
  box-shadow: none;
  margin: 30px 0px 0px;
  border: 1px solid ${(props) => props.theme.adaptativo("neutral80", "surface3")};
  border-radius: 4px;
  background-color: ${(props) => props.theme.adaptativo("neutral100", "surface3")};

  svg {
    color: ${(props) => props.theme.textoContrato};
  }

  &.MuiAccordion-root {
    margin: 0;
    margin-bottom: 16px;
  }

  @media (max-width: 768px) {
    &.MuiAccordion-root {
      margin: 0 8px 16px;
    }
  }
`;

export const AccordionSummarySimples = styled(AccordionSummary)`
  height: 56px;

  @media (max-width: 768px) {
    height: 86px;
  }
`;

export const AccordionSummarySimplesSemChip = styled(AccordionSummary)`
  height: 56px;
`;

export const TypographyTituloSimples = styled(Typography)`
  font-family: "Comfortaa", sans-serif;
  font-style: normal;
  font-weight: 500;
  font-size: 19px;
  line-height: 21px;
  letter-spacing: 0.15px;

  color: ${(props) => props.theme.adaptativo("neutral40", "neutral100")};

  display: flex;
  gap: 33px;

  @media (max-width: 768px) {
    flex-direction: column;
    gap: 5px;
  }
`;

export const ChipPagamentoOK = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;

  width: 122px;
  height: 24px;
  border-radius: 99px;
  padding: 0px 8px;
  background-color: rgba(209, 255, 238, 1);

  font-size: 12px;
  font-family: "Sorce Sans Pro", sans-serif;
  color: rgba(0, 109, 68, 1);
`;

export const ChipCobrancaGerada = styled(ChipPagamentoOK)`
  background-color: ${({ theme }) => theme.cores.semanticAlert1Antiga};
  color: rgba(156, 143, 22, 1);
`;

export const ChipGerarCobranca = styled(ChipPagamentoOK)`
  width: 110px;
  background-color: rgba(251, 162, 162, 1);
  color: rgba(147, 0, 10, 1);
`;

export const StyledAccordion = styled(Accordion)`
  box-shadow: none;
  margin: 0;
  margin-bottom: 0;
  background-color: ${(props) => props.theme.adaptativo("brand10", "brand70")};

  svg {
    color: ${(props) => props.theme.textoContrato};
  }

  &.MuiAccordion-root {
    margin: 0;
  }

  @media (max-width: 768px) {
    &.MuiAccordion-root {
      margin: 0 8px;
    }
  }
`;

export const TypographyTitulo = styled(Typography)`
  font-family: "Source Sans Pro";
  font-style: normal;
  font-weight: 600;
  font-size: 19px;
  line-height: 24px;
  letter-spacing: 0.5px;

  color: ${(props) => props.theme.adaptativo("neutral40", "neutral100")};
`;

export const LinhaClara = styled(AccordionDetails)`
  background: ${(props) => props.theme.cores.surface2};
  display: flex;
  align-items: center;
  height: 86px;
  justify-content: space-between;
  padding-right: 220px;
  gap: 10px;

  @media (max-width: 768px) {
    padding-right: 12px;
  }
`;

export const TextoLinha = styled.p`
  font-family: "Source Sans Pro";
  font-style: normal;
  font-weight: 400;
  font-size: 17px;
  line-height: 21px;
  display: flex;
  align-items: center;
  text-align: left;
  letter-spacing: 0.5px;
  color: ${(props) => props.theme.cores.textoContrato};

  @media (max-width: 414px) {
    font-size: 14px;
  }
`;

export const LinhaEscura = styled(AccordionDetails)`
  background: ${(props) => props.theme.adaptativo("surface3", "neutral10")};
  display: flex;
  align-items: center;
  height: 86px;
  padding-right: 220px;
  gap: 10px;
  justify-content: space-between;

  @media (max-width: 768px) {
    padding-right: 12px;
  }
`;

export const ConteudoInformacaoPlano = styled.div`
  padding: 13px 16px 20px;
  font-size: 19px;

  display: flex;
  justify-content: space-between;

  @media (max-width: 768px) {
    flex-direction: column;
  }
`;

export const InputETexto = styled.div`
  @media (max-width: 768px) {
    > p {
      margin-bottom: 16px;
    }
  }
`;

export const ContainerInputPorcentagemValor = styled.div`
  position: relative;
  max-height: 56px;
  max-width: 270px;

  margin-bottom: 16px;
`;

export const ContainerBotoesInput = styled.div`
  display: flex;
  margin-top: 9px;
  position: absolute;
  top: 0;
  right: 0;
`;

export const BotaoInputValor = styled.button`
  width: 46px;
  height: 55px;

  border: none;

  font-size: 16px;
  font-weight: 600;
  font-family: "Source Sans Pro", sans-serif;

  cursor: pointer;

  transition: filter 0.2s;

  &:hover {
    filter: brightness(0.8);
  }
`;

export const BotaoInputPorcentagem = styled.button`
  width: 46px;
  height: 55px;

  border: none;
  border-top-right-radius: 4px;

  cursor: pointer;

  transition: filter 0.2s;

  > svg {
    height: 30px;
    width: 16px;
  }

  &:hover {
    filter: brightness(0.8);
  }
`;

export const TextoInformacoesPlano = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: end;

  > p:nth-last-child(1) {
    margin-top: 50px;
  }

  @media (max-width: 768px) {
    align-items: baseline;

    > p:first-child {
      margin-top: 24px;
    }

    > p:nth-last-child(1) {
      margin-top: 16px;
    }
  }
`;

export const TextoValor = styled.p`
  display: flex;
  gap: 5px;

  font-size: 19px;
  font-weight: 600;
  color: ${(props) => props.theme.adaptativo("neutral50", "neutral100")};
`;

export const Valor = styled.p`
  font-size: 19px;
  font-weight: 700;

  color: ${(props) => props.theme.adaptativo("neutral50", "neutral100")};
`;

export const ValorVermelho = styled(Valor)`
  color: ${({ theme }) => theme.cores.semanticDanger2};
`;

export const ValorVerde = styled(Valor)`
  color: ${({ theme }) => theme.cores.semanticSuccess1Antiga};
`;

export const ConteudoInformacoesPagamento = styled(ConteudoInformacaoPlano)`
  padding-top: 0;
  align-items: center;

  @media (max-width: 768px) {
    align-items: baseline;
  }
`;

export const ParagrafoNormal = styled.p`
  font-size: 19px;
  color: ${(props) => props.theme.adaptativo("neutral50", "neutral100")};
  font-weight: 400;
`;

export const ParagrafoBold = styled(ParagrafoNormal)`
  font-weight: 600;
`;

export const TextoData = styled.span`
  color: ${(props) => props.theme.adaptativo("neutral50", "neutral100")};
  font-size: 19px;
  font-weight: 700;
`;

export const ConteudoPeriodoTestes = styled(ConteudoInformacaoPlano)`
  align-items: center;

  @media (max-width: 900px) {
    align-items: baseline;
    flex-direction: column;
  }
`;

export const ContainerBotoesTeste = styled.div`
  @media (max-width: 900px) {
    margin-top: 8px;
  }
`;

export const ContainerSessoes = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;

  padding: 24px;
  height: 90px;

  background-color: ${(props) => props.theme.adaptativo("corCardRelatorioClientes", "brand80")};
  border-bottom: 1px solid ${(props) => props.theme.cores.borderAccordion};

  > h1 {
    font-size: 24px;
    font-weight: 400;
    line-height: 36px;
    color: ${(props) => props.theme.adaptativo("neutral40", "neutral100")};
  }

  @media (max-width: 768px) {
    font-size: 19px;
    margin: 0 8px;
  }
`;

export const ContainerSessaoAdicionalBranco = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;

  padding: 24px;
  height: 90px;

  border-bottom: 1px solid ${(props) => props.theme.cores.borderAccordion};

  > h1 {
    font-size: 24px;
    font-weight: 400;
    line-height: 36px;
    color: ${(props) => props.theme.adaptativo("neutral40", "neutral100")};
  }

  @media (max-width: 768px) {
    font-size: 19px;
    margin: 0 8px;
    padding: 24px 0 24px 24px;
  }
`;

export const ContainerContadorSessoes = styled.div`
  display: flex;
  align-content: center;
  gap: 10px;

  > span {
    font-size: 19px;
    font-weight: 500;
    font-family: "Poppins", sans-serif;
    text-align: center;

    width: 20px;
  }

  > button > svg {
    height: 20px;
    width: 20px;
    color: ${(props) => props.theme.cores.actionActive};
  }
`;

export const ContainerSessaoAdicional = styled.div`
  width: 50%;
  display: flex;
  align-items: center;
  justify-content: space-between;

  @media (max-width: 768px) {
    width: 100%;
  }
`;

export const ContainerInputValor = styled.div`
  box-sizing: border-box;
  width: 104px;
`;

export const inputTeste = styled.input`
  background-color: red;
`;

export const StyledTextField = styled(TextField)`
  max-width: 132px;

  .MuiInput-input {
    text-align: center;
  }
  .MuiInput-root {
    font-size: 20px;
    font-family: "Source Sans Pro", sans-serif;

    color: ${(props) => props.theme.adaptativo("neutral40", "neutral100")};
  }

  .MuiTypography-root {
    font-size: 20px;
    font-family: "Source Sans Pro", sans-serif;

    color: ${(props) => props.theme.adaptativo("neutral40", "neutral100")};
  }

  .MuiInputBase-root {
    padding: 0;
  }

  input[type="number"]::-webkit-inner-spin-button,
  input[type="number"]::-webkit-outer-spin-button {
    -webkit-appearance: none;
    margin: 0;
  }
`;

export const StyledCampoDeTexto = styled(CampoDeTexto)`
  height: 56px;
`;
